import type { TQueryConstructor } from '@hozana/api/types'

import type { MESSAGE_TYPE } from './constants'

type TStartConversationMutationPayload = {
  users: number[]
  prayerId: number
  payload?: { userId?: number; correspondentId?: number; intentionId?: number; text?: string }
  type: MESSAGE_TYPE.THANKS_INTENTION_PRAYER
}

export const startConversationMutation: TQueryConstructor<TStartConversationMutationPayload, number> = ({
  users,
  type,
  payload = {},
  prayerId,
}) => ({
  queryKey: `startConversation`,
  url: `/message`,
  params: { users, type, payload, prayerId },
  method: 'POST',
})
